import * as React from 'react';

import { FormattedMessage } from 'js/lib/coursera.react-intl';

import type ReviewSchemaPart from 'pages/open-course/peerReview/reviewTypes/structured/partTypes/options/models/schema';

import { Radio, RadioGroup, Typography2 } from '@coursera/cds-core';

import InlineValidationErrorV2 from 'bundles/assess-common/components/InlineValidationErrorV2';
import type { OptionsStructuredPart, OptionsStructuredPartDefinition } from 'bundles/assess-common/types/Reviews';
import type { ValidationError } from 'bundles/assess-common/types/ValidationErrors';
import Content from 'bundles/phoenix/components/Content';

import _t from 'i18n!nls/ondemand';

import 'css!./__styles__/OptionsFormPart';

type Props = {
  disabled: boolean;
  reviewSchemaPart: typeof ReviewSchemaPart;
  reviewPart?: OptionsStructuredPart;
  onChange?: (change: OptionsStructuredPartDefinition) => void;
  validationError?: ValidationError | null;
};

class OptionsFormPart extends React.Component<Props> {
  handleChange = (optionId: $TSFixMe) => {
    if (!this.props.disabled && this.props.onChange) {
      this.props.onChange({ choice: optionId });
    }
  };

  render() {
    const { disabled, reviewSchemaPart, reviewPart, validationError } = this.props;

    const partId = reviewSchemaPart.get('id');
    const options = reviewSchemaPart.getSortedOptions();
    const promptId = `${reviewSchemaPart.id}-prompt`;
    const validationLabelId = reviewSchemaPart.id ? `form-part-label-${reviewSchemaPart.id}` : undefined;

    return (
      <div className="rc-OptionsFormPart">
        <div className="options-prompt">
          <Content contentId={promptId} content={reviewSchemaPart.get('prompt')} />
        </div>
        <InlineValidationErrorV2 id={validationLabelId} validationError={validationError} />
        <RadioGroup aria-labelledby={`${promptId} ${validationLabelId}`}>
          {options.map((option: $TSFixMe) => (
            <Radio
              key={option.optionId}
              className="peer-option-input"
              disabled={disabled}
              name={`peer-options-${partId}`}
              value={option.optionId}
              checked={reviewPart && option.optionId === reviewPart.definition.choice}
              aria-checked={reviewPart && option.optionId === reviewPart.definition.choice}
              onChange={() => this.handleChange(option.optionId)}
              label={
                (
                  <div className="option-contents">
                    {reviewSchemaPart.get('isScored') && (
                      <Typography2 component="div" variant="subtitleMedium" color="inherit">
                        <FormattedMessage
                          message={_t('{points, plural, one{# point} other{# points}}')}
                          points={option.points.toString()}
                        />
                      </Typography2>
                    )}
                    <div data-testid="option-cml-container">
                      <Content assumeStringIsHtml={false} content={option.display} />
                    </div>
                  </div>
                ) as unknown as string
              }
            />
          ))}
        </RadioGroup>
      </div>
    );
  }
}

export default OptionsFormPart;
